// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesTableRow-moduleemptyCell__N6k0n TableCellBase-moduleTableCellBase__GDcv6 TableCell-moduleTableCell__hIV2f";
var _2 = "RequestProfileTabActivitiesTableRow-moduletitleText__t3Tcj TableCellText-moduleTableCellText__b5epO";
export { _1 as "emptyCell", _2 as "titleText" }
